import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useMutation, useQueryClient } from '@tanstack/vue-query'

export const useObjectTypeDelete = (id: number) => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: () => http.del(`/manuals/object-types/${id}`),
  })

  const remove = async () => {
    try {
      await mutation.mutateAsync()

      addSuccess(trs('itf.object_types_deleted'))

      await queryClient.invalidateQueries({ queryKey: ['load_object_types'] })
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    remove,
  }
}
